import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import "../css/Modal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__